import axios from 'axios';

import { CLIENT_HEADER_NAME, CLIENT_HEADER_VALUE } from './http-headers';

const httpHostelClient = axios.create();

httpHostelClient.defaults.headers.common[CLIENT_HEADER_NAME] =
  CLIENT_HEADER_VALUE;

httpHostelClient.interceptors.request.use(
  config => {
    return new Promise(resolve => {
      resolve(config);
    });
  },

  error => {
    return Promise.reject(error);
  }
);

httpHostelClient.interceptors.response.use(
  response => {
    if (
      response &&
      response.hasOwnProperty('data') &&
      response.hasOwnProperty('config')
    ) {
      // console.log(response.config.url, response.data);
    }

    return response;
  },

  error => {
    return Promise.reject(error);
  }
);

export default httpHostelClient;
